import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { Map } from 'immutable';
import PropTypes from 'prop-types';
import BaseInput from 'flow/components/ui-components/BaseInput';
import { ContactFieldMaxLength } from 'flow/utils/contact-utils';
import { jsx as _jsx } from "react/jsx-runtime";
var ContactEditField = /*#__PURE__*/function (_React$PureComponent) {
  function ContactEditField() {
    var _this;
    _classCallCheck(this, ContactEditField);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ContactEditField, [].concat(args));
    _defineProperty(_this, "handleKeys", function (event) {
      // Prevent line breaks with enter key
      if (event.keyCode === 13) {
        event.preventDefault();
      }
    });
    _defineProperty(_this, "getValue", function () {
      var field_value = _this.props.field_value;
      if (Map.isMap(field_value)) {
        return field_value.get('value', null);
      }
      return typeof field_value === 'string' ? field_value : null;
    });
    /*
     * Trim the string from unwanted empty spaced in the end when finished entering a string
     */
    _defineProperty(_this, "handleFinishedInput", function (event) {
      event.target.value = event.target.value.trimEnd();
      _this.props.field_func(event);
    });
    _defineProperty(_this, "isEditable", function () {
      var _this$props = _this.props,
        field_value = _this$props.field_value,
        disableEdit = _this$props.disableEdit;
      if (disableEdit) return false;
      if (Map.isMap(field_value) && field_value.has('editable')) {
        return field_value.get('editable');
      }
      return true;
    });
    return _this;
  }
  _inherits(ContactEditField, _React$PureComponent);
  return _createClass(ContactEditField, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        field_key = _this$props2.field_key,
        field_func = _this$props2.field_func,
        label = _this$props2.label;
      if (!field_key) {
        return null;
      } else {
        return /*#__PURE__*/_jsx("div", {
          className: "flex flex-col justify-center gap-y-6",
          children: /*#__PURE__*/_jsx(BaseInput, {
            label: label,
            id: field_key,
            disabled: !this.isEditable(),
            value: this.getValue(),
            onChange: field_func,
            onKeyDown: this.handleKeys,
            onBlur: this.handleFinishedInput,
            maxLength: ContactFieldMaxLength.get(field_key)
          })
        });
      }
    }
  }]);
}(React.PureComponent);
_defineProperty(ContactEditField, "propTypes", {
  field_key: PropTypes.string.isRequired,
  field_value: PropTypes.oneOfType([PropTypes.instanceOf(Map), PropTypes.string]),
  field_func: PropTypes.func,
  label: PropTypes.string.isRequired,
  disableEdit: PropTypes.bool
});
export default ContactEditField;